import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setParentPage: YJSChangeHandler<DatabaseChangeType.SET_PARENT_PAGE> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    if (change.newParentPage) {
      field.parentPage = change.newParentPage.contentId;
    } else {
      field.parentPage = undefined;
    }
  });
};
